import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 16px;
	margin-bottom: 16px;
	width: 100%;
	background-color: ${({ theme }) => theme.white ?? "#fff"};
	border-radius: 4px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const Title = styled.span`
	font-weight: bold;
	font-size: 14px;
`;

export const IconWrapper = styled.span`
	display: inline-flex;
	align-items: center;
	cursor: help;
	color: ${({ theme }) => theme.pantone656C ?? "#666"};
`;

export const FieldsRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: flex-start;
	width: 100%;
`;

export const Field = styled.div<{ $minWidth?: string }>`
	flex: 1 1 ${({ $minWidth }) => $minWidth ?? "200px"};
	min-width: ${({ $minWidth }) => $minWidth ?? "200px"};
`;
